import {
  ChatReactionRequestSchema,
  ChatReactionResponseSchema,
  seal,
  type ChatReactionRequest,
} from "@kraahl/contract"
import { postJson } from "@/lib/api/post-json"

export class ChatReactionError extends Error {
  readonly status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = "ChatReactionError"
    this.status = status
  }
}

export async function setChatMessageReaction(intent: {
  messageId: string
  emoji: string
}): Promise<{ counts: Record<string, number>; viewerEmoji: string | null }> {
  const body = {
    messageId: intent.messageId,
    emoji: intent.emoji,
  } satisfies ChatReactionRequest

  const parsed = ChatReactionRequestSchema.safeParse(body)
  if (!parsed.success) {
    throw new ChatReactionError("Invalid reaction payload", 400)
  }

  const res = await postJson("/api/chat/reaction", seal<ChatReactionRequest>(body))
  if (!res.ok) {
    let detail = `Reaction failed (${res.status})`
    try {
      const payload = (await res.json()) as { error?: string }
      if (payload?.error) detail = payload.error
    } catch {}
    throw new ChatReactionError(detail, res.status)
  }

  const json = await res.json()
  const response = ChatReactionResponseSchema.parse(json)
  return { counts: response.counts, viewerEmoji: response.viewerEmoji }
}
